import React, { useEffect, useState } from "react";
import RemarksIcon from "../../../asset/images/checkerOffMarket/RemarksOffMarket.svg";
import attachIcon from "../../../asset/images/orange-attachment.svg";
import approveIcon from "../../../asset/images/righticon-green.svg";
import infoIcon from "../../../asset/images/yellow-info.svg";
import rejIcon from "../../../asset/images/cancelRed-Icon.svg";
import { alphaNumericUppercase, handlePasteText } from "../../../CommonMethhods/CommonMethods";
import { Off_Market } from "../../../Configuration/API_URL";
import { toast } from "react-toastify";
import grayuparrow from "../../../asset/images/gray-uparrow.svg";
import SmallLoader from "../../../Components/Common/smallLoader";
import uparrowSort from "../../../asset/images/up-arrow-acc.svg";
import downarrowSort from "../../../asset/images/down-arrow-acc.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { axiosMultipartInstance } from "../../../CommonMethhods/axiosInstance";

const PendingForReview = ({ sr, setSelectedSR, onSkip, refreshSRList, refreshCardData }) => {
  const storeToken = localStorage.getItem("ssoToken");
  const [expandedStocks, setExpandedStocks] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [remarksInput, setRemarksInput] = useState("");
  const [loader, setLoader] = useState(false);
  const getRole = localStorage.getItem("cosmosProjectRole");
  const [showApproveModal, setShowApproveModal] = useState(false);
   const [sortConfig, setSortConfig] = useState({
      field: "",
      direction: "asc",
    });
  
    const handleSort = (field, type) => {
      setSortConfig((prev) => ({
        field,
        type,
        direction:
          prev.field === field && prev.direction === "asc"
            ? "desc"
            : "asc",
      }));
    };

    useEffect(() => {
  if (showModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [showModal]);

  useEffect(() => {
  if (groupedStocks?.length > 0) {
    setExpandedStocks("0-0");
  }
}, [sr]);

  const groupedStocks = sr?.Trades?.reduce((acc, trade) => {
    const existing = acc.find((item) => item.ISIN === trade.ISIN);

    if (existing) {
      existing.trades.push(trade);
    } else {
      acc.push({
        ...trade,
        trades: [trade],
      });
    }

    return acc;
  }, []);

  const toggleStock = (clientIdx, stockIdx) => {
    const key = `${clientIdx}-${stockIdx}`;

    setExpandedStocks((prev) =>
      prev === key ? null : key
    );
  };

  const openRejectModal = (clientIdx) => {
    setRemarksInput("");
    setShowModal(true);
  };

  const confirmApprove = () =>{
    handleCheckerStatus("Approved", sr?.ClientCode)
  }


  const handleSubmit = () => {
    if (remarksInput.trim().length < 10) {
    return;
  }

   handleCheckerStatus(
    "Rejected",
    sr?.ClientCode,
    remarksInput.trim()
  );
  };

  const handleCancel = () => {
    setShowModal(false);
    setRemarksInput("");
  };

  const viewSupportingDoc = async (clCode) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("clientCode", clCode);

    try {

      const getDetails = await axiosMultipartInstance.post(
        Off_Market.downloadSupportingDoc,
        formData,

      );
      const res = getDetails?.data;
      if (res?.status === 0) {
        window.open(res?.data, "_blank", "noopener,noreferrer");
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  const sectionTitle =
    sr.status === "Rejected" ? "Rejected" :
      sr.status === "Approved" ? "Approved" :
        "Pending for Review";


  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [datePart] = dateString.split(" ");
    const [month, day, year] = datePart.split("/");
    return `${day}-${month}-${year}`;
  };

  const checkerStatusApprReject = async (status, clCode, remarks = "") => {
    const formData = new FormData();
    formData.append("Status", status);
    formData.append("clientCode", clCode);

    if (status === "Rejected") {
      formData.append("Remark", remarks);
    }

    try {
      const getDetails = await axiosMultipartInstance.post(
        Off_Market.approveRejectStatus,
        formData,

      );
      const res = getDetails?.data;
      if (res?.status === 0) {
        toast.success(res?.data?.Message);

        setSelectedSR((prev) => ({
          ...prev,
          status: status,
          rejectionRemarks: remarks,
        }));
        refreshCardData?.();
         refreshSRList?.();
        if(status === "Rejected"){
          setShowModal(false);
          setRemarksInput("");
         } else if(status === "Approved"){
            setShowApproveModal(false);
         }
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCheckerStatus = (status, clCode, remarks = "") => {
    checkerStatusApprReject(status, clCode, remarks);
  };

  const renderSortIcons = (field) => (
    <span className="sort-icons">
      <img
        src={uparrowSort}
        alt="upsort"
        className={
          sortConfig.field === field &&
          sortConfig.direction === "asc"
            ? "sort-arrow active"
            : "sort-arrow"
        }
      />
      <img
        src={downarrowSort}
        alt="downsort"
        className={
          sortConfig.field === field &&
          sortConfig.direction === "desc"
            ? "sort-arrow active"
            : "sort-arrow"
        }
      />
    </span>
  );

  
  

  return (
    <>

      <div className="step-content mb-extra">
        <div className="preview-wrapper">

          <div className="summary-title-wrap">
            <span className="summary-title">{sectionTitle}</span>

          </div>

          <div className="client-header mb-15">
            <div className="client-wrapper">
              <span className="initials">
                {sr?.ClientName?.slice(0, 2).toUpperCase()}
              </span>

              <div className="cl-wrapper">
                <span className="cl-name">{sr?.ClientName}</span>
                <div className="client-code">
                  Client code-{sr?.ClientCode}
                </div>
              </div>
            </div>


            <div className="wrap-upload wrap-flex">
              <span className="records">
                {sr?.TotalRecordCount} RECORDS • {sr?.TotalISINCount} ISINS
              </span>
              <button className="view-doc-btn"
                onClick={() => viewSupportingDoc(sr?.ClientCode)}>
                {loader ?
                  <SmallLoader />
                  :
                  <>
                    <img src={attachIcon} alt="attachment" /> VIEW SUPPORTING DOC
                  </>}
              </button>
              {getRole === "checker" &&
                <>
                  {sr.status === "Pending" && (
                    <>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="approve-tooltip" className="approve-tooltip">Approve</Tooltip>}
                    >
                      <button
                        className="status-btns"
                        onClick={()=> setShowApproveModal(true)}
                      >
                        <img src={approveIcon} alt="Approve" />
                      </button>
                    </OverlayTrigger>

                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="reject-tooltip" className="reject-tooltip">Reject</Tooltip>}
                    >
                      <button
                        className="status-btns"
                        onClick={() => openRejectModal(0)}
                      >
                        <img src={rejIcon} alt="Reject" />
                      </button>
                    </OverlayTrigger>
                    </>
                    
                  )}
                </>
              }
            </div>

          </div>

          {groupedStocks.map((stock, stockIdx) => {

            const key = `0-${stockIdx}`;
            // const isExpanded = expandedStocks.has(key);
            const isExpanded = expandedStocks === key;
            const transferredQty = Number(stock.TotalTransferredQty || 0);
            const uploadedQty = Number(stock.TotalISINQty || 0);
            const mismatchQty = Math.abs(
              transferredQty - uploadedQty
            );

            const sortedTrades = [...stock.trades].sort((a, b) => {
                if (!sortConfig.field) return 0;

                const { field, direction, type } = sortConfig;

                let valueA;
                let valueB;

                switch (field) {
                  case "exchange":
                    valueA = a.Exch;
                    valueB = b.Exch;
                    break;

                  case "price":
                    valueA = Number(a.AvgPrice || 0);
                    valueB = Number(b.AvgPrice || 0);
                    break;

                  case "date":
                    valueA = new Date(a.TradeDate);
                    valueB = new Date(b.TradeDate);
                    break;

                  default:
                    return 0;
                }

                if (type === "string") {
                  return direction === "asc"
                    ? String(valueA).localeCompare(String(valueB))
                    : String(valueB).localeCompare(String(valueA));
                }

                if (type === "number") {
                  return direction === "asc"
                    ? valueA - valueB
                    : valueB - valueA;
                }

                if (type === "date") {
                  return direction === "asc"
                    ? valueA - valueB
                    : valueB - valueA;
                }

              return 0;
            });

            const isMatched = mismatchQty === 0;

            return (
              <div key={stockIdx} className="isin-section">
                <div
                  className={`table-footer-card table-flex ${isExpanded ? "open-card" : ""}`}
                  onClick={() => toggleStock(0, stockIdx)}
                // className= "table-footer-card" onClick={() => toggleStock(0, stockIdx)}
                >

                  <div className="wrap-close-card">
                    <div className="wrap-isin">
                      <span className="bold-text">{stock.SchName}</span>
                      <span className="light-text">{stock.ISIN}</span>
                    </div>

                    <div className="wrap-upload">
                      <span className="records">{stock.TotalISINQty} Quantity</span>

                      <img className={`${isExpanded ? "open-accordian" : "arrow-accordian "}`} src={grayuparrow} alt="downarrow" />

                      {/* <i className={`fa fa-chevron-${isExpanded ? "up" : "down"}`} /> */}
                    </div>
                  </div>

                  <div className={`ckr-match-row${stock.Flag === "failed" ? "--mismatch" : ""}`}>
                    <span className="ckr-match-col ckr-match-col--transferred">
                      <span className="bold-text font-14 banner-qty">{stock.TotalTransferredQty?.toLocaleString()} shares</span>{" "}
                      Transferred to Bajaj Demat
                    </span>
                    <span className="ckr-match-col">
                      <span className={`bold-text font-14 banner-qty ${stock?.Flag === "success" ? "ckr-status--match" : "ckr-status--mismatch"}`}>
                        {stock.TotalISINQty?.toLocaleString()} shares</span>{" "}
                      Total uploaded buy Qty
                    </span>
                    <span className={`ckr-match-col ckr-match-col--status${stock.Flag === "success" ? " ckr-status--match" : " ckr-status--mismatch"
                      }`}>
                      {stock.Flag === "success"
                        ? <span className="font-14 banner-qty">Quantities Match</span>
                        : <span className="font-14 banner-qty">Mismatch ({mismatchQty} shares)</span>
                      }{" "}
                      <span className="ckr-match-label">Match status</span>
                    </span>
                  </div>

                  {isExpanded && stock.trades.length > 0 && (
                    <div className="ckr-trades-wrapper scroll-table">
                      <table className="data-table ckr-table">
                        <thead>
                          <tr>
                            <th>SR No.</th>
                            <th className="sortable-header"
                              onClick={(e) => {
                                  e.stopPropagation();
                                  handleSort("exchange", "string");
                                }}>
                                Exchange {renderSortIcons("exchange")}
                            </th>
                            <th>Symbol</th>
                            <th>ISIN</th>
                            <th>Quantity</th>
                            <th className="sortable-header"
                              onClick={(e) => {
                                 e.stopPropagation();
                                 handleSort("price", "number")}}>
                                Avg Price ₹ {renderSortIcons("price")}
                                
                              </th>
                            {/* <th>Trade Date</th> */}
                            <th className="sortable-header"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSort("date", "date")}}>
                                Trade Date {renderSortIcons("date")}
                              </th>
                          </tr>
                        </thead>
                        <tbody>
                          {sortedTrades.map((trade, index) => (
                            <tr key={trade.srNo}>
                              <td>{index + 1}</td>
                              <td>{trade.Exch}</td>
                              <td>{trade.Symbol}</td>
                              <td>{trade.ISIN}</td>
                              <td>{trade.Qty}</td>
                              <td>{trade.AvgPrice}</td>
                              <td>{formatDate(trade.TradeDate)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

      </div>


      {showModal && (
        <div className="ckr-modal-overlay">
          <div className="ckr-modal" onClick={(e) => e.stopPropagation()}>
            <div className="ckr-modal__header">
              <span>Add Remarks</span>
              <button className="ckr-modal__close" onClick={handleCancel}>
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="ckr-modal__body">
              <textarea
                placeholder="Enter remarks here..."
                value={remarksInput}
                rows={5}
                minLength={10}
                maxLength={100}
                autoFocus
                onChange={(e) =>
                  setRemarksInput(alphaNumericUppercase(e.target.value, 1000))
                }
               onPaste={handlePasteText({
                value: remarksInput,
                setValue: setRemarksInput,
                maxLength: 100,
                regex: /[^A-Z0-9\s]/g,
              })}
              />
            </div>
            <div className="ckr-modal__footer">
              <button className="ckr-modal__cancel" onClick={handleCancel}>CANCEL</button>
              <button
                className="ckr-modal__submit"
                onClick={handleSubmit}
                disabled={remarksInput.trim().length < 10}
                // disabled={!remarksInput.trim()}
              >
                SUBMIT
              </button>
            </div>
          </div>
        </div>
      )}

        <Modal
        show={showApproveModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new delete-modal"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setShowApproveModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="profile-modal-content">
            <div className='iba-worning'>
              <div className="wrap-infoicon">
                <img src={infoIcon} alt="email icon" className="info-icon" />
              </div>
              <span className='conf-text'>Are you sure you want to Approve this record ?</span>
            </div>

            <div className="footer-actions modal-btns">
              <button className="back-btn" onClick={() => {
                setShowApproveModal(false);
              }}>CANCEL</button>
              <button className="submit-btns" onClick={confirmApprove}>
                  SUBMIT
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


export default PendingForReview;
